import {
  AccountActionTypes,
  AccountType,
  Account,
  Feature,
  Permission
} from './Types';

export const UPDATE_ACCOUNT: AccountActionTypes = 'UPDATE_ACCOUNT';
export const IMPERSONATION_UPDATE_ACCOUNT: AccountActionTypes = 'IMPERSONATION_UPDATE_ACCOUNT';

export const ADMIN: AccountType = 'ADMIN';
export const CLIENT: AccountType = 'CLIENT';
export const STAFF: AccountType = 'STAFF';

export const INITIAL_ACCOUNT_STATE: Account = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  accountType: CLIENT,
  cancelled: false,
  authorities: []
};

export const PROGRAM: Feature = 'PROGRAM';
export const BUSINESS: Feature = 'BUSINESS';
export const ACCOUNT: Feature = 'ACCOUNT';
export const MEMBER: Feature = 'MEMBER';
export const MARKETING: Feature = 'MARKETING';
export const PAYMENT: Feature = 'PAYMENT';
export const ATTENDANCE: Feature = 'ATTENDANCE';
export const CALENDAR: Feature = 'CALENDAR';
export const TEST: Feature = 'TEST';
export const POS: Feature = 'POS';
export const PACKAGE: Feature = 'PACKAGE';

export const FEATURES: Array<Feature> =
  [PROGRAM, BUSINESS, ACCOUNT, MEMBER, MARKETING, PAYMENT, ATTENDANCE, CALENDAR, POS, PACKAGE, TEST];
  
export const FULL: Permission = 'FULL';
export const NONE: Permission = 'NONE';
export const READ: Permission = 'READ';
export const UPDATE: Permission = 'UPDATE';
export const CREATE: Permission = 'CREATE';

export const PERMISSIONS: Array<Permission> = [FULL, NONE, READ, UPDATE, CREATE];



// WEBPACK FOOTER //
// ./src/account/Constants.tsx